import { render, staticRenderFns } from "./ReporteTiemposParos.vue?vue&type=template&id=2df22bb8&"
import script from "./ReporteTiemposParos.vue?vue&type=script&lang=js&"
export * from "./ReporteTiemposParos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports